// After a successful payment: open the customer's order history with the new
// order selected (signed-in customers), or the confirmation page (guests).
// Both show the estimated ready / arrival time. Replaces the old popup window
// (which most mobile browsers blocked anyway).
import { DINECENTRAL_AUTH } from "../../../../Firebase.dinecentral";
import { saveOrderMeta } from "../../../../service/OrderEta";

export function goToPlacedOrder(orderCode: string, orderType: string, deliveryQuote: any, restaurantId: string | null | undefined, extra: { orderId?: string | null; total?: number | null; itemCount?: number | null } = {}): void {
  saveOrderMeta(orderCode, {
    orderTime: new Date().toISOString(),
    orderType: String(orderType || ""),
    storeId: restaurantId || null,
    orderCode,
    orderId: extra.orderId ?? null,
    total: extra.total ?? null,
    itemCount: extra.itemCount ?? null,
    deliveryQuote: deliveryQuote
      ? { estimatedDuration: deliveryQuote.estimatedDuration ?? null, drivingDistance: deliveryQuote.drivingDistance ?? null, deliveryType: deliveryQuote.deliveryType ?? null }
      : null,
  });
  const currentBasename = window.location.pathname.match(/^\/r\/[^\/]+/)?.[0] || "";
  const signedIn = !!DINECENTRAL_AUTH.currentUser;
  const target = signedIn
    ? `${currentBasename}/recent?order=${encodeURIComponent(orderCode)}`
    : `${currentBasename}/orderConfirmation?id=${encodeURIComponent(orderCode)}&r=${encodeURIComponent(restaurantId || "")}`;
  // Give the toast a beat, then move on. Same window — no popup.
  window.setTimeout(() => window.location.assign(target), 600);
}
